var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.643799C16.7103 0.643799 21.3561 5.28955 21.3561 11C21.3561 16.7104 16.7104 21.3561 11 21.3561C5.28955 21.3561 0.643799 16.7104 0.643799 11C0.643799 5.28955 5.28955 0.643799 11 0.643799ZM11 2.17791C6.11873 2.17791 2.17804 6.11866 2.17804 10.9998C2.17804 15.881 6.1188 19.8217 11 19.8217C15.8811 19.8217 19.8219 15.881 19.8219 10.9998C19.8219 6.11866 15.8811 2.17791 11 2.17791ZM11 4.86277C11.4238 4.86277 11.767 5.2063 11.767 5.62983V10.9995C11.767 11.2115 11.6782 11.4001 11.5393 11.5389L8.29098 14.7993C7.99132 15.099 7.49981 15.099 7.20015 14.7993C6.9005 14.5 6.9005 14.0082 7.20015 13.7085L10.2328 10.6881V5.63003C10.2328 5.20623 10.5764 4.86298 10.9999 4.86298L11 4.86277Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.aba0e3a26153c7b71e1cb05936771649.svg";
export { ForwardRef as ReactComponent };